import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, Typography, IconButton } from '@mui/material';
import { getIcon } from '../../../utils/IconHandler';
import { formatDate } from '../../../utils/DateUtils';
import './Profile.scss'; // Importa los estilos

const PersonalInfoCard = ({ user, onEdit }) => {
    const { t } = useTranslation();

    if (!user) {
        return null; // or a loading spinner, or a placeholder component
    }

    return (
        <Card>
            <CardContent>
                <div className="header">
                    <Typography variant="h5" component="div">
                        <span className="roboto-light">{t('personal_information')}</span>
                    </Typography>
                    <IconButton onClick={onEdit}>
                        {getIcon('settings')}
                    </IconButton>
                </div>
                <div className="content-profile">
                    {user.profilePictureUrl && (
                        <div className="image-container">
                            <img src={user.profilePictureUrl} alt="Profile" className="profile-image" />
                        </div>
                    )}
                    <div className="text-container">
                        <Typography variant="body2">
                            <p><span className="roboto-regular">{t('name')}:</span><span className="roboto-light"> {user.firstName} {user.lastName}</span></p>
                            <p style={{ marginTop: '6px' }}><span className="roboto-regular">{t('email')}:</span><span className="roboto-light"> {user.email}</span></p>
                            <p style={{ marginTop: '6px' }}><span className="roboto-regular">{t('phone')}:</span><span className="roboto-light"> {user.phone}</span></p>
                            <p style={{ marginTop: '6px' }}><span className="roboto-regular">{t('address')}:</span><span className="roboto-light"> {user.address}</span></p>
                            <p style={{ marginTop: '6px' }}><span className="roboto-regular">{t('birthdate')}:</span><span className="roboto-light"> {formatDate(user.birthDate)}</span></p>
                        </Typography>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};

export default PersonalInfoCard;
